import React from 'react';

import { fixNewsUrl } from '../../util/urlHelpers';

const NewsLink = (props) => {
  const {
    className,
    link,
    children,
  } = props;

  const newsLink = fixNewsUrl(link);

  return (
    <a
      className={className}
      target='_blank'
      href={newsLink}
    >
      {children}
    </a>
  );
};

export default NewsLink;
